import React, { Component } from "react";
import { connect } from "react-redux";
import Profile from "../components/profile";

import { close_snack_bar } from "../../../common/snackbar/action";

import {  updateProfile,updateProfilePic } from "../../Home/action";
export class Controller extends Component {
  render() {
    return <Profile {...this.props} />;
  }
}
export const mapStateToProps = (store) => {
  return {
    loader: store.loader,
    snackbar: store.snackbar,
    QrCode: store.QrCode,
    login: store.login,
  };
};
export const mapDispatchToProps = (dispatch) => {
  return {
    // clear_login: () => {
    //     dispatch(clear_login())
    // },
    close_snack_bar: () => {
      dispatch(close_snack_bar());
    },

    // viewAllQr: (searchInput,) => {
    //     dispatch(viewAllQr(searchInput,));
    // },
    // viewQrById: (id) => {
    //     dispatch(viewQrById(id));
    // },

    // createQr: (qr_id, name, email, video_link) => {
    //     dispatch(createQr(qr_id, name, email, video_link));
    // },
    // UserRegister: (name, email, mobile, access) => {
    //   dispatch(UserRegister(name, email, mobile, access));
    // },
    updateProfile: (token, user_id,name,oldpassword,password) => {
      dispatch(updateProfile(token, user_id,name,oldpassword,password));
    },
    updateProfilePic: (token, user_id,profilepic) => {
        dispatch(updateProfilePic(token, user_id,profilepic));
      },
   
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Controller);
